<template>
  <div class="feed_record">
    <van-nav-bar
        title="历史反馈"
        left-arrow
        @click-left="onClickLeft"
    />
    <div class="record" v-if="record.length > 0">
      <div class="item" :class="{read: item.is_read == 2}" v-for="(item, key) in record" :key=key>        
        <em class="new" v-if="item.is_read == 1">新消息</em>
        <div class="content">{{item.content}}</div>
        <div class="desc">
          <span>{{formatDate(item.created_at)}}</span>
          <span @click="toDetail(item.id)">查看 ></span>
        </div>
      </div>
    </div>
    <div class="non_record" v-if="record.length == 0">
      <van-empty
        class="custom-image"
        :image=EmptyBG
        description="暂无提交任何反馈记录～"
      />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { NavBar, Empty } from 'vant'
import EmptyBG from '@/assets/images/feedback/empty.png'
Vue.use(NavBar).use(Empty);

export default {
  created() {
    this.getList()
  },
  data() {
    return {
      userid: this.$g.getCookie('userid'),
      record: [],
      EmptyBG
    }
  },
  methods: {
    onClickLeft: function () {
      this.$router.push({path: '/help'})
    },
    toDetail: function(id) {
      this.$router.push({path: '/feedback/detail', query: {
        itemid : id
      }})
    },
    getList: function() {
      const params = {
        userid: this.userid
      }
      this.$http.get('/api/user_web/show_feedback', {params: params}).then((res) => {
        res.data.list.forEach((item) => {          
          this.record.push(item)
        })
      })
    },
    formatDate: function(timestamp) {
      timestamp = parseInt(timestamp * 1000)
      let date = new Date(timestamp)
      return this.$g.formatDateTime(date, "yyyy-MM-dd hh:mm")
    }
  }
}
</script>

<style lang="less" scoped>
.feed_record {
    display: block;
    width: 100%;
    max-width: 3.75rem;
    min-height: 100vh;
    background-color: rgb(250, 250, 250);
    overflow: hidden;

    .record {
      display: block;
      width: 3.43rem;
      margin: 0 auto;
      margin-top: .12rem;
      overflow: hidden;

      .item {
        display: block;
        width: 100%;
        background-color: #FFFFFF;
        margin-bottom: .12rem;
        position: relative;
        color: #333333;
        overflow: hidden;
        
        .new {
          display: block;
          width: .48rem;
          height: .2rem;
          background: #FF4019;
          border-radius: .06rem 0 .06rem 0;
          font-size: 12px;
          color: #FFFFFF;
          text-align: center;
          line-height: .2rem;
          font-style: normal;
          position: absolute;
          overflow: hidden;
        }
        .content {
          display: block;
          width: calc(100% - .32rem);
          padding-top: .24rem;
          padding-bottom: .16rem;
          padding: .24rem .16rem .16rem .16rem;
          font-size: 14px;
          overflow: hidden;
        }
        .desc {
          display: block;
          height: .39rem;
          padding: 0 .16rem;
          border-top: 1px solid #F5F7FA;
          font-size: 12px;
          overflow: hidden;

          span {
            line-height: .39rem;
          }
          span:first-child {
            float: left;
          }
          span:last-child {
            float: right;
            font-size: 14px;
            color: #FF7F4B;
          }
        }
      }
      .item.read {
        color: #999999;
      }
    }
    .non_record {
      display: flex;
      width: 100%;
      height: calc(100vh - 1.6rem);
      flex-direction: column;
      justify-content: center;
      align-content: center;
      overflow: hidden;
    }
    /deep/ .van-empty__image {
      width: .65rem;
      height: .65rem;
    }
    /deep/ .van-nav-bar{
      margin-top: .26rem;
    }
    /deep/.van-icon {
      color: #666666;
    }
    /deep/.van-nav-bar__title {
      font-size: 18px;
      color: #333333;
    }
}
</style>